import React, { useEffect, useRef, useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './Order.css';
import priceFormat from './../../../utils/showPriceFormat';

const POrder = (props) => {
    const { id, number, factureNumber, fullName, telephone, info, submitPostPrice } = props;
    const { products, totalPrice, insertDate, status, address, postPrice, pencilMode } = props;
    const [showPostPriceInput, setShowPostPriceInput] = useState(false);
    const [newPostPrice, setNewPostPrice] = useState('');
    const [showOrder, setShowOrder] = useState(false);
    const inputRef = useRef(null);
    useEffect(() => {
        if(!showPostPriceInput)
        return;
        inputRef.current.focus()
    },[showPostPriceInput])

    return (
        <React.Fragment>

            <div className="order-layer">
                <header className="order-layer-header">
                    <div className="d-flex justify-content-between align-items-center p-2">
                        <span className="order-number d-flex flex-wrap col-6 px-0" >
                            <div className="mr-1">
                                <span className="font-weight-bold text-muted border rounded-circle px-2">{number}</span>
                            </div>
                            <div>
                                <span className="gs">{factureNumber.split('-')[0]}</span>
                                <span className="">-</span>
                                <span className="">{factureNumber.split('-')[1]}</span>
                            </div>
                            <div className="col-12 ml-3">
                                <span className='small'>
                                    {priceFormat(totalPrice)} تومان
                                </span>
                            </div>
                        </span>
                        <span className="col-1 px-0">
                            <button
                                style={{ position: 'relative', top: '7px', left: '7px' }}
                                className="btn btn-success rounded-circle px-1 py-0"
                                onClick={() => setShowOrder(!showOrder)}
                            >
                                <i className={`fa fa-arrow-${showOrder ? 'up' : 'down'}`}></i>
                            </button>

                        </span>
                        <span className="order-date col-5 px-0 text-right">
                            <small>{insertDate.split(' ')[0]}</small>
                            <small>{insertDate.split(' ')[1]}</small>
                        </span>
                    </div>
                </header>
                <Collapse
                    id="contentcollapse"
                    in={showOrder}
                >
                    <div>
                        {
                            <section className="scrap-section p-2">
                                <div>
                                    <div className="order-facture">
                                        <h1>فاکتور</h1>
                                        <div className="d-flex flex-wrap justify-content-between mt-3">
                                            <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                                <h6 className="font-weight-bold">اطلاعات مشتری</h6>
                                                <span className="font-weight-bold ">
                                                    <span >نام گیرنده</span>
                                                    <span className="mx-1">:</span>
                                                    <span className="text-muted">{fullName}</span>
                                                </span>
                                                <span className="font-weight-bold ">
                                                    <span >تلفن</span>
                                                    <span className="mx-1">:</span>
                                                    <span className="text-muted">{telephone}</span>
                                                </span>
                                                <span className="font-weight-bold ">
                                                    <span >آدرس</span>
                                                    <span className="mx-1">:</span>
                                                    <p className="text-muted">{address}</p>
                                                </span>
                                                <span className="font-weight-bold ">
                                                    <span >توضیحات</span>
                                                    <span className="mx-1">:</span>
                                                    <p className="text-muted">{info}</p>
                                                </span>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 d-flex flex-column">
                                                <h6 className="font-weight-bold">اطلاعات محصولات</h6>
                                                <table className="table table-sm" style={{fontSize:'.8rem'}}>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col">نام محصول</th>
                                                            <th scope="col">تعداد</th>
                                                            <th scope="col">مبلغ</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            products.map((item, index) => 
                                                                <tr
                                                                    key={item._id}
                                                                >
                                                                    <th scope="row">{index + 1}</th>
                                                                    <td>{item.title}</td>
                                                                    <td>{item.count} {item.unit}</td>
                                                                    <td>{item.price} تومان</td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 px-0 pl-xl-5">
                                                <h6 className="font-weight-bold mt-0 ">مبلغ</h6>
                                                <div className="d-flex justify-content-between ">
                                                    <span>مجموع هزینه</span>
                                                    <span>
                                                        {priceFormat(String(totalPrice))}<span className="ml-1">تومان</span>
                                                    </span>
                                                </div>
                                                <div className="d-flex justify-content-between mt-2">
                                                    <span>هزینه پیک</span>
                                                    {
                                                        !showPostPriceInput ?
                                                        <span>
                                                            {
                                                                pencilMode &&
                                                                <button className='btn btn-sm btn-warning px-1 py-0 mr-2'
                                                                    onClick={() => {
                                                                        setShowPostPriceInput(true);
                                                                    }}
                                                                >
                                                                    <i className='fa fa-pencil'></i>
                                                                </button>
                                                            }
                                                            {priceFormat(String(postPrice))}<span className="ml-1">تومان</span>
                                                        </span>
                                                        :
                                                        <span>
                                                            <button className='btn btn-sm btn-success px-1 py-0 mr-1'
                                                                onClick={() => {
                                                                    submitPostPrice(id, newPostPrice)
                                                                    setShowPostPriceInput(false);
                                                                }}
                                                            >
                                                                <i className='fa fa-check'></i>
                                                            </button>
                                                            <button className='btn btn-sm btn-danger px-1 py-0 mr-2'
                                                                onClick={() => setShowPostPriceInput(false)}
                                                            >
                                                                <i className='fa fa-close'></i>
                                                            </button>
                                                            <input 
                                                                type={'text'}
                                                                style={{width:'85px', height:'23px'}}
                                                                className="form-control d-inline-block ltr"
                                                                ref={inputRef}
                                                                value={newPostPrice}
                                                                onChange={e => setNewPostPrice(e.target.value)}
                                                            />
                                                            <span className='ml-2'>تومان</span>
                                                        </span>
                                                    }
                                                </div>
                                                <div className="d-flex justify-content-between text-success mt-2">
                                                    <span>مبلغ پرداختی</span>
                                                    <span>
                                                        {priceFormat(String(Number(totalPrice) + Number(postPrice)))}<span className="ml-1">تومان</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        }
                    </div>

                </Collapse>
            </div>
            <div className="d-flex justify-content-center mt-2">
                {
                    status === 'delivered' ?
                        <button className="btn btn-danger  py-0 px-1 ml-auto"
                            disabled={true}
                            onClick={props.deleteOrder}
                        ><i className="fa fa-trash"></i></button>
                        :
                        <React.Fragment>
                            <button className="btn btn-success rounded-pill mx-1 order-btn"
                                onClick={props.selectOrder}
                            >{status === 'processing' ? 'اتمام' : 'تایید'}</button>
                            <button className="btn btn-danger rounded-pill mx-1 order-btn"
                                onClick={props.deleteOrder}
                            >حذف</button>
                        </React.Fragment>
                }
            </div>
        </React.Fragment>

    );
}

export default POrder;